import { render, staticRenderFns } from "./CreateContact.vue?vue&type=template&id=8b6d073a&scoped=true&"
import script from "./CreateContact.vue?vue&type=script&lang=js&"
export * from "./CreateContact.vue?vue&type=script&lang=js&"
import style0 from "./CreateContact.vue?vue&type=style&index=0&id=8b6d073a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b6d073a",
  null
  
)

export default component.exports